<div class="display-value-wrapper d-inline-flex">
  @if (item.faIconName) {
    <mat-icon class="fa-icon"><i class="fa fa-fw" [ngClass]="item.faIconName"></i></mat-icon>
  }

  <span [class.ps-2]="!item.faIconName">{{ item.displayName }}</span>
</div>
